export { default } from './IsBrowser';
